export const config = {
  AUTH0_DOMAIN: `parsley-sims.us.auth0.com`,
  AUTH0_CLIENTID: 'UEW0q7J76i95TiEMi9lhIyZibxgPAL9D',
  AUTH0_AUDIENCE: 'https://parsley-sims.flax.cloud',
  AUTH0_CLAIM_NAMESPACE: 'https://parsley.flaxadvisors.cloud/claims',
  AUTH_SERVER_URL: 'https://parsley-sims-flax.us.auth0.com',
};

